import { BetslipType } from '../../../core/betslip-type';
import { LinearModuleType } from '../../linear/linear-module-type';

export type LinearTypes = Record<LinearModuleType, boolean>;

export interface IBaseTypeState {
    activeTypes: BetslipType[];
    currentSelectedType: BetslipType | null;
    selectedByUser: boolean;
    linearTypes: LinearTypes;
    original: {
        activeTypes: BetslipType[];
        currentSelectedType: BetslipType | null;
        selectedByUser: boolean;
    };
}

export const defaultBaseTypeState: IBaseTypeState = Object.freeze({
    activeTypes: [],
    currentSelectedType: null,
    selectedByUser: false,
    linearTypes: {
        [BetslipType.Single]: false,
        [BetslipType.Combo]: false,
        [BetslipType.System]: false,
        [BetslipType.Teaser]: false,
        [BetslipType.BetBuilder]: false,
    },
    original: {
        activeTypes: [],
        currentSelectedType: null,
        selectedByUser: false,
    },
});
